import topLaptops from '../../images/image-top-laptops.jpg';
import retroPcs from '../../images/image-retro-pcs.jpg';
import gamingGrowth from '../../images/image-gaming-growth.jpg';

const postInfo = [
  {
    id: 1,
    img: retroPcs,
    imgAlt: '',
    number: '01',
    heading: 'Reviving Retro PCs',
    description: 'What happens when old pcs are given modern upgrades?'
  },

  {
    id: 2,
    img: topLaptops,
    imgAlt: '',
    number: '02',
    heading: 'Top 10 Laptops of 2022',
    description: 'Our best picks for various needs and budgets.'
  },

  {
    id: 3,
    img: gamingGrowth,
    imgAlt: '',
    number: '03',
    heading: 'The Growth of Gaming',
    description: 'How the pandemic has sparked fresh opportunities.'
  },
]

export default postInfo;